import { z } from 'zod';

export const getMetabaseJWTSchema = z.object({
  jwt: z.string(),

});
